<template>
  <div class="relation">
    <!-- 第一部分 -->
    <div class="relation_1 pd_b20">
      <p class="title color_fff txt_c">联系我们</p>
    </div>
    <!-- 第二部分 -->
    <div class="relation_2 pd_b20">
      <div class="clear_fd">
<!--        <div class="ft_l relation_2_map" id="allmap">-->

<!--        </div>-->
        <div class="ft_l relation_2_map" id="allmap" style="background:#f5f5f5;text-align:center;line-height:628px;color:#999;">
          地图功能暂不可用
        </div>
        <div class="ft_r relation_2_ul">
          <div :class="selectNav == item.id ? 'relation_2_li select' : 'relation_2_li nav'" v-for="(item,index) in list" :key="index" @click="cutNav(item.id)">
            <p class="relation_2_li_txt1">{{item.name}}</p>
            <p class="relation_2_li_txt2">{{item.address}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="allmap" style="width:500px;height:300px"></div> -->
  </div>
</template>
<script>
// 导入BMap组件
// import BMap from "BMap";
export default {
  data() {
    return {
      selectNav: 1,
      list: [
        {
          id: 1,
          name: "深圳总部",
          address: "广东省深圳市龙岗区万科星火Online 17栋",
          w: 22.612951,
          j: 114.069371
        },
        {
          id: 2,
          name: "广州量智",
          address: "广东省广州市黄浦区萝岗敏捷广场敏荣街B6-108",
          w: 23.196899,
          j: 113.487721
        },
        {
          id: 3,
          name: "海口公司",
          address: "海南省海口市龙华区梧桐路大样电动汽车服务中心",
          w: 19.964252,
          j: 110.337941
        },
        {
          id: 4,
          name: "广州嘉势",
          address: "广东省广州市白云区嘉禾街望岗大马路38号长旺大厦",
          w: 23.243451,
          j: 113.292273
        },
        {
          id: 5,
          name: "武汉公司",
          address:
            "湖北省武汉市东湖新技术开发区银久科技产业园二期1栋",
          w: 30.48598,
          j: 114.428455
        },
        {
          id: 6,
          name: "中山公司",
          address:
            "广东省中山市火炬开发区依云路1号君华新城2区29幢",
          w: 22.542127,
          j: 113.494056
        },
        {
          id: 7,
          name: "佛山公司",
          address:
            "广东省佛山市南海区桂城街道简平路1号天安数码城2栋1410",
          w: 23.025121,
          j: 113.174379
        }
      ]
    };
  },
  mounted: function() {
    // console.log(BMap);
    // // var marker = new BMap.Marker(point);        // 创建标注
    // // map.addOverlay(marker);                     // 将标注添加到地图中
    // setTimeout(()=>{
    //   this.showMap(this.list[0].j, this.list[0].w);
    // },200)

    console.log("地图功能已禁用 - 百度地图API未授权");

  },
  methods: {
    cutNav: function(id) {
      this.selectNav = id;
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].id == id) {
          // this.showMap(this.list[i].j, this.list[i].w);
          return true;
        }
      }
    },

    // showMap: function(j, w) {
    //   var map = new BMap.Map("allmap"); // 创建地图实例
    //   var point = new BMap.Point(j, w); // 创建点坐标
    //   map.centerAndZoom(point, 15); // 初始化地图，设置中心点坐标和地图级别
    //   map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    //   addMarker(point, 0);
    //   function addMarker(point, index = 0) {
    //     // 创建图标对象
    //     var myIcon = new BMap.Icon(
    //       "http://www.charge-i.com/point.png",
    //       new BMap.Size(23, 25),
    //       {
    //         // 指定定位位置。
    //         // 当标注显示在地图上时，其所指向的地理位置距离图标左上
    //         // 角各偏移10像素和25像素。您可以看到在本例中该位置即是
    //         // 图标中央下端的尖角位置。
    //         anchor: new BMap.Size(10, 25),
    //         // 设置图片偏移。
    //         // 当您需要从一幅较大的图片中截取某部分作为标注图标时，您
    //         // 需要指定大图的偏移位置，此做法与css sprites技术类似。
    //         imageOffset: new BMap.Size(0, 0 - index * 25) // 设置图片偏移
    //       }
    //     );
    //     // 创建标注对象并添加到地图
    //     var marker = new BMap.Marker(point, { icon: myIcon });
    //     map.addOverlay(marker);
    //   }
    // }
  }
};
</script>
<style>
/* 第一部分样式 */
.relation_1 {
  height: 300px;
  background-image: url("../assets/relation/relation_bg_1.png");
  background-size: 100% 100%;
  padding-top: 172px;
}
/* 第二部分样式 */
.relation_2 {
  padding-top: 40px;
  padding-bottom: 40px;
  background-image: url("../assets/relation/relation_bg_2.png");
  background-size: 100% 100%;
}
.relation_2_map {
  width: 65%;
  height: 628px;
}
.relation_2_ul {
  width: 34%;
  height: 628px;
  overflow-y: scroll;
}
.relation_2_li {
  box-sizing: border-box;
  padding: 30px 24px;
}
.relation_2_li_txt1 {
  font-size: 24px;
  color: #333;
  font-weight: bold;
}
.relation_2_li_txt2 {
  font-size: 17px;
  color: #666;
}
.nav {
  background-image: url("../assets/relation/relation_nav.png");
  background-size: 100% 100%;
}
.select {
  background-image: url("../assets/relation/relation_select.png");
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/relation.vue